import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { capturePostHogSafely } from '@/Domain/helper/posthogCapture';
import { getCurrentScenarioId } from '@/context';

export const usePostHogAnalytics = () => {
  const postHog = usePostHog();

  const capture = useCallback(
    (event: PostHogEventEnum, properties?: Record<string, unknown>) => {
      capturePostHogSafely(postHog, event, {
        scenario_id: getCurrentScenarioId(),
        ...properties,
      });
    },
    [postHog],
  );

  return { capture, postHog };
};
